import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import trackerState from '@/components/trackerState/trackerState'

@Component({
  components: {
    trackerState
  }
})
export default class TrackerContentState extends Vue {
  @Getter getCurrentOrder: any

  currentIndex = 1
  listStatus = ''

  get listStatusService () {
    let status
    if (this.getCurrentOrder.is_takeout) {
      status = [
        'waiting_restaurant_confirmation',
        'preparing_order',
        'waiting_pickup_client',
        'order_completed'
      ]
    } else {
    }
    status = [
      'waiting_for_external_payment',
      'waiting_restaurant_confirmation',
      // 'preparing_order',
      // 'waiting_pickup_deliveryman',
      // 'delivering_order',
      'order_completed'
    ]
    return status
  }
}
